var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.8925 4.5H5.0925C4.8975 4.5 4.71 4.5075 4.53 4.53C2.5125 4.7025 1.5 5.895 1.5 8.0925V11.0925C1.5 14.0925 2.7 14.685 5.0925 14.685H5.3925C5.5575 14.685 5.775 14.7975 5.8725 14.925L6.7725 16.125C7.17 16.6575 7.815 16.6575 8.2125 16.125L9.1125 14.925C9.225 14.775 9.405 14.685 9.5925 14.685H9.8925C12.09 14.685 13.2825 13.68 13.455 11.655C13.4775 11.475 13.485 11.2875 13.485 11.0925V8.0925C13.485 5.7 12.285 4.5 9.8925 4.5ZM4.875 10.5C4.455 10.5 4.125 10.1625 4.125 9.75C4.125 9.3375 4.4625 9 4.875 9C5.2875 9 5.625 9.3375 5.625 9.75C5.625 10.1625 5.2875 10.5 4.875 10.5ZM7.4925 10.5C7.0725 10.5 6.7425 10.1625 6.7425 9.75C6.7425 9.3375 7.08 9 7.4925 9C7.905 9 8.2425 9.3375 8.2425 9.75C8.2425 10.1625 7.9125 10.5 7.4925 10.5ZM10.1175 10.5C9.6975 10.5 9.3675 10.1625 9.3675 9.75C9.3675 9.3375 9.705 9 10.1175 9C10.53 9 10.8675 9.3375 10.8675 9.75C10.8675 10.1625 10.53 10.5 10.1175 10.5Z",
    fill: "#445386"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4849 5.0925V8.0925C16.4849 9.5925 16.0199 10.6125 15.0899 11.175C14.8649 11.31 14.6024 11.13 14.6024 10.8675L14.6099 8.0925C14.6099 5.0925 12.8924 3.375 9.89244 3.375L5.32494 3.3825C5.06244 3.3825 4.88244 3.12 5.01744 2.895C5.57994 1.965 6.59994 1.5 8.09244 1.5H12.8924C15.2849 1.5 16.4849 2.7 16.4849 5.0925Z",
    fill: "#445386"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.ef5c3ae0496fac583cc0cd7a707055a9.svg";
export { ForwardRef as ReactComponent };